module.exports = __webpack_public_path__ + "img/limes-350x184.57470cda.jpg";